import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoadTrips } from 'customHooks/useLoadTrips';
import { AccountHeaderContainer } from './style';


const AccountHeader: FC = () => {

  const location = useLocation();
  const { trips } = useLoadTrips();
  let headerTitle = '';
  let shwoHeaderTitle = true;
  let headerTitleAdd = '';
  const debug = false;

  const pathParts = location.pathname.split('/');
  const isCreditCardDetailsPage = location.pathname.startsWith('/account/billing/credit-card-details/');
  const isEditCreditCardPage = location.pathname.startsWith('/account/billing/edit-credit-card/');

  const isBillingCardPage = isCreditCardDetailsPage || isEditCreditCardPage;
  const billingCardGroupId = pathParts[4];

  const billingCardBookingCode =
    trips?.[billingCardGroupId]?.primaryBookingCode ||
    trips?.[billingCardGroupId]?.bookings?.[0]?.reservationCode ||
    '';


  let showProfileLink = false;

  switch (true) {
    case location.pathname === '/account/dashboard':
      headerTitle = 'Dashboard';
      break;
    case location.pathname === '/account/personal-details':
      headerTitle = 'Personal Details';
      showProfileLink = true;
      break;
    case location.pathname === '/account/email':
      headerTitle = 'Email';
      showProfileLink = true;
      break;
    case location.pathname === '/account/phone-number':
      headerTitle = 'Phone Number';
      showProfileLink = true;
      break;
    case location.pathname === '/account/bookings':
      headerTitle = 'Bookings';
      break;
    case location.pathname === '/account/cancel-group-booking':
      headerTitle = 'Cancel Booking';
      break;
    case isCreditCardDetailsPage:
      headerTitle = 'Credit Card';
      break;
    case isEditCreditCardPage:
      headerTitle = 'Edit Credit Card';
      break;
    case location.pathname.split('/').length === 4:



      const bookings = trips[location.pathname.split('/')[3]]?.bookings || [];

      //  RHCFW-255
      // const displayedCodes = bookings.length > 3 
      //   ? [...bookings.slice(0, 3).map(booking => booking.reservationCode), '...'] 
      // : bookings.map(booking => booking.reservationCode);

      // headerTitle = `Booking ${displayedCodes.join(', ')}`;

      if (debug) {
        console.log('trips from header = ', trips);
      }

      if (bookings.length === 1) {
        headerTitle = `Booking ${trips[location.pathname.split('/')[3]]?.primaryBookingCode ?? ''}`;
      } else {
        const primaryBookingCode = trips[location.pathname.split('/')[3]]?.primaryBookingCode;
        headerTitle = primaryBookingCode ? `Group Booking (${primaryBookingCode})` : "Group Booking";
      }

      break;
    case location.pathname.startsWith('/account/bookings/add-guest-info/'):
      headerTitle = 'Add Guest Information';
      break;
    case location.pathname.startsWith('/account/bookings/edit-guest-info/'):
      headerTitle = 'Edit Guest Information';
      break;
    case location.pathname.startsWith('/account/bookings/add-ons/'):

      headerTitle = 'Add-ons';

      const bookingId = location.pathname.split('/')[5];
      const groupId = location.pathname.split('/')[4];

      if (debug) {
        console.log('bookingId = ', bookingId);
        console.log('groupId = ', groupId);
      }


      const bookingsList = trips[groupId]?.bookings || [];
      const roomIndex = bookingsList.findIndex(booking => booking.bookingId === bookingId);

      if (roomIndex !== -1) {
        headerTitleAdd = `: Room ${roomIndex + 1}`;
      }


      break;
    case location.pathname.startsWith('/account/bookings/modify-dates/'):
      headerTitle = 'Modify Dates'

      const bookingIdModifyDates = location.pathname.split('/')[5];
      const groupIdModifyDates = location.pathname.split('/')[4];

      if (debug) {
        console.log('bookingIdModifyDates = ', bookingIdModifyDates);
        console.log('groupIdModifyDates = ', groupIdModifyDates);
      }


      const bookingsListModifyDates = trips[groupIdModifyDates]?.bookings || [];
      const roomIndexModifyDates = bookingsListModifyDates.findIndex(booking => booking.bookingId === bookingIdModifyDates);

      if (roomIndexModifyDates !== -1) {
        headerTitleAdd = `: Room ${roomIndexModifyDates + 1}`;
      }

      break;

    case location.pathname.startsWith('/account/bookings/modify-room-type/'):
      headerTitle = 'Modify Room Type';

      const bookingIdModifyRoomType = location.pathname.split('/')[5];
      const groupIdModifyRoomType = location.pathname.split('/')[4];
      const roomIdModifyRoomType = location.pathname.split('/')[6];

      if (debug) {
        console.log('bookingIdModifyRoomType = ', bookingIdModifyRoomType);
        console.log('groupIdModifyRoomType = ', groupIdModifyRoomType);
        console.log('roomIdModifyRoomType = ', roomIdModifyRoomType);
      }

      const bookingsListModifyRoomType = trips[groupIdModifyRoomType]?.bookings || [];
      const roomIndexModifyRoomType = bookingsListModifyRoomType.findIndex(
        booking => booking.bookingId === bookingIdModifyRoomType
      );

      if (roomIndexModifyRoomType !== -1) {
        headerTitleAdd = `: Room ${roomIndexModifyRoomType + 1}`;
      }

      break;

    case location.pathname.startsWith('/account/bookings/guest-information/'):
      headerTitle = 'Guest Information'
      break;
    case location.pathname.startsWith('/account/bookings/cancel-group-booking/'):
      headerTitle = 'Cancel Booking'
      break;
    case location.pathname === '/account/billing':
      headerTitle = 'Billing';
      break;
    case location.pathname === '/account/security':
      headerTitle = 'Security';
      //shwoHeaderTitle = false;
      break;
    case location.pathname === '/help':
      headerTitle = 'Help';
      break;
    default:
      headerTitle = 'Profile';
  }

  if (debug) {
    console.log("headerTitleAdd = ", headerTitleAdd);
  }

  return (
    <AccountHeaderContainer>

      {location.pathname === '/account/dashboard' ? (
        <>
          <h1>Account</h1>
          {/* <h3>Customize Your Account Settings</h3> */}
        </>
      ) : isBillingCardPage ? (
        <>
          <div className="accountLink">
            <a href="/account">Account</a>

            <span>
              {'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}
            </span>

            <a href="/account/billing">
              Billing
            </a>

            <span>
              {'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}
            </span>

            <a href={`/account/bookings/${billingCardGroupId}`}>
              Booking {billingCardBookingCode}
            </a>

            <span>
              {'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}
            </span>

            {isEditCreditCardPage ? (
              <>
                <a
                  href={`/account/billing/credit-card-details/${billingCardGroupId}`}
                >
                  Credit Card
                </a>

                <span>
                  {'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}
                </span>

                <span>Edit Credit Card</span>
              </>
            ) : (
              <span>Credit Card</span>
            )}
          </div>

          {shwoHeaderTitle ? (
            <h2>
              {headerTitle}
              {headerTitleAdd}
            </h2>
          ) : null}
        </>
      ) : (location.pathname.split('/').length === 4) ? (
        <>
          <div className="accountLink">
            <a href='/account'>Account</a>
            <span>{'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}</span>
            <a href='/account/bookings'>Bookings</a>
            <span>{'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}</span>
            <span>{headerTitle}</span>
          </div>
          {shwoHeaderTitle ? (<h2>{headerTitle}{headerTitleAdd}</h2>) : (null)}
        </>
      ) : (
        location.pathname.split('/').length === 5 ||
        location.pathname.startsWith('/account/bookings/add-guest-info') ||
        location.pathname.startsWith('/account/bookings/add-ons') ||
        location.pathname.startsWith('/account/bookings/edit-guest-info') ||
        location.pathname.startsWith('/account/bookings/modify-dates/') ||
        location.pathname.startsWith('/account/bookings/modify-room-type/')
      ) ? (
        <>
          <div className="accountLink">
            <a href='/account'>Account</a>
            <span>{'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}</span>
            <a href='/account/bookings'>Bookings</a>
            <span>{'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}</span>
            <a href={`/account/bookings/${location.pathname.split('/')[4]}`}>
              Booking {trips[location.pathname.split('/')[4]]?.bookings[0]?.reservationCode}
            </a>
            <span>{'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}</span>
            <span>{headerTitle}</span>
          </div>
          {shwoHeaderTitle ? (<h2>{headerTitle}{headerTitleAdd}</h2>) : (null)}
        </>
      ) : (
        <>
          <div className="accountLink">
            <a href='/account'>Account</a>
            <span>{'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}</span>
            {showProfileLink && (
              <>
                <a href="/account/profile">Profile</a>
                <span>{'\u00A0\u00A0\u00A0>\u00A0\u00A0\u00A0'}</span>
              </>
            )}
            <span>{headerTitle}</span>
          </div>
          {shwoHeaderTitle ? (<h2>{headerTitle}{headerTitleAdd}</h2>) : (null)}
        </>
      )}
    </AccountHeaderContainer>
  );
};

export default AccountHeader;
